module.exports = __webpack_public_path__ + "img/krotoski-centrum-lodz.c43b51d7.jpg";